<template>
  <div class="cban" style="height: 100%">
    <div
      class="ctpx-non-product-item"
      :style="{
        backgroundImage: `url(${cBanner.contentBannerBackground.url})`,
      }"
    >
      <h2
        :class="{ 'light-mode': cBanner.lightMode }"
        class="display-3"
        v-if="cBanner.title"
      >
        {{ cBanner.title }}
      </h2>
      <p v-if="cBanner.body" :class="{ 'light-mode': cBanner.lightMode }">
        <strong>{{ cBanner.body }}</strong>
      </p>
      <a
        :href="cBanner.ctaLink"
        class="btn btn-black"
        v-if="cBanner.ctaTitle"
        >{{ cBanner.ctaTitle }}</a
      >
    </div>
    <!-- .ctpx-non-product-item -->
  </div>
  <!-- .col-sm-6 -->
</template>

<script src="./ctrl-content-banner-card.js"></script>
